import { render, staticRenderFns } from "./VariadoresDashboard.vue?vue&type=template&id=45468426"
import script from "./VariadoresDashboard.vue?vue&type=script&lang=js"
export * from "./VariadoresDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports